module.exports = __webpack_public_path__ + "img/purple-2-squiggly-solid.bbfe4a1f.svg";